<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <div class="text-h3 mb-2" v-text="'Создать набор'" />
      </v-col>
    </v-row>
    <v-row>
      <v-form v-model="valid">
        <v-container fluid>
          <v-row>
            <!-- Заголовок -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.name"
                label="Заголовок"
                outlined
                required
                :rules="rules.required"
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Слаг -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.slug"
                label="Слаг"
                outlined
                required
                :rules="rules.required"
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Категория -->
            <v-col cols="12" md="7">
              <v-select
                v-model="data.categoryId"
                :items="getCategoriesList"
                item-text="name"
                item-value="id"
                outlined
                label="Категория"
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Описание -->
            <v-col cols="12" md="7">
              <v-textarea
                v-model="data.description"
                label="Описание"
                outlined
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Тег заголовка -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.h1"
                label="Тег заголовка"
                outlined
                required
                :rules="rules.required"
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Мета заголовок -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.metaTitle"
                label="Мета заголовок"
                outlined
                required
                :rules="rules.required"
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Мета описание -->
            <v-col cols="12" md="7">
              <v-textarea
                v-model="data.metaDescription"
                label="Мета описание"
                outlined
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Цена -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.price"
                label="Цена"
                outlined
                required
                :rules="[...rules.required, ...rules.number]"
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Старая Цена -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.oldPrice"
                label="Старая цена"
                outlined
                required
                :rules="[...rules.required, ...rules.number]"
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Бонусы -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.bonusAdd"
                label="Бонусы"
                outlined
                required
                :rules="[...rules.required, ...rules.number]"
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Стикер -->
            <v-col cols="12" md="7">
              <v-select
                v-model="data.stickerType"
                item-text="text"
                item-value="type"
                :items="stickerType"
                label="Стикер"
                outlined
              />
            </v-col>
            <!-- Стикер Маркетинг -->
            <v-col cols="12" md="7">
              <v-select
                v-model="data.stickerMarketing"
                item-text="text"
                item-value="type"
                :items="stickerMarketing"
                label="Стикер Маркетинг"
                outlined
              />
            </v-col>
            <!-- Изображение -->
            <v-col cols="12" md="7">
              <upload-image
                v-model="data.image"
                color="orange"
                label="Загрузить изображение набора"
              >
                Загрузить изображение
              </upload-image>
            </v-col>
            <!-- Индекс сортировки -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.sortOrder"
                label="Индекс сортировки"
                outlined
                required
                :rules="rules.number"
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Стоп лист -->
            <v-col cols="12" md="7">
              <v-checkbox
                v-model="data.hasStop"
                label="Стоп лист"
                required
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Показывать в главном меню -->
            <v-col cols="12" md="7">
              <v-checkbox
                v-model="data.showInMainMenu"
                label="Показывать в главном меню"
                required
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Блюда в наборе -->
            <v-col md="7">
              <v-autocomplete
                v-model="menuItems.model"
                :items="getMenuItemsList"
                item-text="name"
                outlined
                chips
                deletable-chips
                multiple
                label="Блюда в наборе"
                :return-object="true"
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <v-col cols="12" />
            <v-col
              md="3"
              v-for="(v, i) in menuItems.model"
              :key="`bundlmodif-${i}`"
            >
              <v-card>
                <v-card-title>
                  <div class="text-h4 mb-2" v-text="v.name" />
                </v-card-title>
                <v-card-text>
                  <v-select
                    v-model="menuItems.data[i].modificationMenuItemId"
                    :items="getModificationsList"
                    label="Модификаторы:"
                    outlined
                    item-text="name"
                    item-value="id"
                    :disabled="loading"
                    :loading="loading"
                  />
                </v-card-text>
              </v-card>
            </v-col>
            <!-- Submit -->
            <v-col cols="12" />
            <v-col md="7">
              <v-btn
                block
                color="primary"
                :loading="loading"
                :disabled="loading"
                @click.prevent="submitBundles"
              >
                Создать
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <v-snackbar v-model="snackbar">
        {{ snackbarText }}
      </v-snackbar>
    </v-row>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import UploadImage from './../../components/UploadImage'

  export default {
    components: { UploadImage },
    data () {
      return {
        data: {
          name: '',
          slug: '',
          categoryId: null,
          description: '',
          h1: 'h1',
          metaTitle: '',
          metaDescription: '',
          price: '',
          oldPrice: '',
          bonusAdd: '',
          stickerType: '',
          stickerMarketing: '',
          image: '',
          sortOrder: 1,
          status: true,
          hasStop: false,
          showInMainMenu: true,
          items: [],
        },
        rules: {
          required: [(v) => !!v || 'Обязательное поле'],
          number: [(v) => !isNaN(Number(v)) || 'Только цифры'],
        },
        menuItems: {
          model: [],
          data: [],
        },
        stickerType: [
          { type: 'child', text: 'Для детей' },
          { type: 'spicy', text: 'Острое меню' },
          { type: 'vegetarian', text: 'Вегетарианское меню' },
        ],
        stickerMarketing: [
          { type: 'new', text: 'Новинка' },
          { type: 'hit', text: 'Хит' },
          { type: 'percent', text: 'Скидка' },
          { type: 'personalDiscount', text: 'Персональаня скидка' },
        ],
        valid: false,
        loading: false,
        snackbar: false,
        snackbarText: '',
      }
    },
    computed: {
      ...mapGetters({
        getCategoriesList: 'categories/getCategoriesList',
        getMenuItemsList: 'menuItems/getMenuItemsList',
        getModificationsList: 'modifications/getModificationsList',
      }),
    },
    watch: {
      'menuItems.model' (newValue) {
        this.menuItems.data = newValue.map((v) => {
          return {
            menuItemId: v.id,
            modificationMenuItemId: v.modifications.id || null,
          }
        })
      },
    },
    created () {
      this.$store.dispatch('categories/fetchCategoriesList', {
        limit: 10000,
        offset: 0,
        page: 1,
      })

      this.$store.dispatch('menuItems/fetchMenuItemsList', {
        limit: 10000,
        offset: 0,
        page: 1,
      })

      this.$store.dispatch('modifications/fetchModificationsList', {
        limit: 10000,
        offset: 0,
        page: 1,
      })
    },
    methods: {
      submitBundles () {
        this.loading = true

        this.data.items = this.menuItems.data
        this.$store
          .dispatch('bundles/createBundles', this.data)
          .then((res) => {
            this.loading = false
            if (res.status === 200) {
              this.$router.push('/bundles')
              this.snackbarText = 'Создана новая запись'
              this.snackbar = true
            }
          })
          .catch((err) => {
            this.loading = false
            this.snackbarText = err.message
            this.snackbar = true
            console.log(err)
          })
      },
    },
  }
</script>
